module.exports = __webpack_public_path__ + "media/category_icons/Dermatology-ce0a20fe.svg";